import React from 'react';
import i18n from '../../locales/i18n';
import { Badge } from 'reactstrap';
import { Utils } from '../../services';

import './EventTitle.css'

const EventTitle = ({ titles, original, textSize, centered, badge, plain, uiLang, defaultLang, inline }) => {
    const lang = uiLang ?? Utils.i18nUiLang(i18n);
    const def = defaultLang ?? Utils.default_lang();
    const { main, subtitle, hasSubtitle } = Utils.resolveEventTitleDisplay(titles, lang, def, original);
    const mainFontSize = textSize ? `${textSize}px` : (hasSubtitle && !inline ? '15px' : undefined);
    const subFontSize = textSize ? `${Math.max(textSize - 2, 11)}px` : '12px';
    const rootClass = [
        'EventTitle',
        plain && 'EventTitle--plain',
        inline && 'EventTitle--inline',
        centered && 'd-flex justify-content-center align-items-center flex-column',
    ].filter(Boolean).join(' ');

    const subtitleEl = (className) => (
        <em className={className} style={{ fontSize: subFontSize }}>{subtitle}</em>
    );

    let titleContent;
    if (hasSubtitle && inline) {
        titleContent = (
            <span style={mainFontSize ? { fontSize: mainFontSize } : undefined}>
                {main}{' '}{subtitleEl('EventTitle__subtitle')}
            </span>
        );
    } else if (hasSubtitle) {
        titleContent = (
            <>
                <div style={mainFontSize ? { fontSize: mainFontSize } : undefined}>{main}</div>
                {subtitleEl(plain ? 'EventTitle__subtitle' : undefined)}
            </>
        );
    } else {
        titleContent = (
            <span style={mainFontSize ? { fontSize: mainFontSize } : undefined}>{main}</span>
        );
    }

    return (
        <div className={rootClass}>
            {titleContent}
            {badge && (
                <div className="opacity-80">
                    <Badge color="info" className="abs bottom-0 right-0">{badge}</Badge>
                </div>
            )}
        </div>
    )
}

export default EventTitle;
